import React, { Component } from "react";
import { connect } from "react-redux";
import * as Yup from "yup";
import { Formik, Form, Field as FormikField } from "formik";
import { Form as BootstrapForm } from "react-bootstrap";
import { toast } from "react-toastify";

import { toggleStep } from "../../../../store/actions/multiplos-actions";
import Field from "../../field";
import StyledButton from "../../button";
import api from "../../../../services/api";
import {
  Container,
  Header,
  Left,
  BackButton,
  Title,
  CloseIcon,
  Content,
  FieldsContainer,
  Fields,
  ButtonContainer,
  Button,
  WithoutInvoicesContainer,
  WithoutInvoices
} from "../styles";

class Invoices extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false
    };
  }

  validationSchema = () =>
    Yup.object().shape({
      lastInvoiceNumber: Yup.number().required("Insira a última nota fiscal"),
      penultimateInvoiceNumber: Yup.number().required(
        "Insira a penúltima nota fiscal"
      )
    });

  requestAddContact = values => {
    const { lastInvoiceNumber, penultimateInvoiceNumber } = values;
    const { userId, document, customerCode } = this.props;
    const userEmail = localStorage.getItem("@UltragazEmpresarial:loginEmail");
    const header = {
      "Content-Type": "application/json"
    };
    const parameters = {
      method: "POST",
      headers: header
    };
    const body = {
      contact: userEmail,
      contactType: "EMAIL",
      customerCode: customerCode,
      document: document,
      contactValidation: {
        lastInvoiceNumber: lastInvoiceNumber,
        penultimateInvoiceNumber: penultimateInvoiceNumber
      }
    };
    api
      .post(`industrial/customer/v1/users/${userId}/contacts`, body, parameters)
      .then(res => {
        this.setState({ loading: false });
        if (res.status === 201) {
          this.requestRegisterContract();
        } else {
          toast.error("Não foi possível realizar a operação, tente novamente!");
        }
      })
      .catch(err => {
        this.setState({ loading: false });
        const erro = err.response;
        if (erro) {
          const message = err.response.data.message;
          if (err.response.status !== 401) {
            toast.error(message);
          }
        } else {
          if (err.response.status !== 401) {
            toast.error("Ocorreu um erro interno na aplicação");
          }
        }
      });
  };

  requestRegisterContract = () => {
    const { userId, customerCode, document } = this.props;
    const access_token = localStorage.getItem(
      "@UltragazEmpresarial:accessToken"
    );
    const header = {
      "Content-Type": "application/json",
      access_token
    };
    const parameters = {
      method: "POST",
      headers: header
    };
    const body = {
      customerCode: customerCode,
      document: document
    };
    api
      .post(
        `industrial/customer/v1/users/${userId}/customers`,
        body,
        parameters
      )
      .then(res => {
        const response = res.data;
        if (res.status === 201) {
          this.props.dispatch(toggleStep(5));
        }
      })
      .catch(err => {
        if (err.response.data.code === "422.014") {
          this.props.dispatch(toggleStep(2));
        } else {
          this.setState({ loading: false });
          const message = err.response.data.message;
          if (message) {
            if (err.response.status !== 401) {
              toast.error(message);
            }
          } else {
            if (err.response.status !== 401) {
              toast.error("Ocorreu um erro interno na aplicação");
            }
          }
        }
      });
  };

  render() {
    const { close, back } = this.props;
    return (
      <Formik
        initialValues={{
          lastInvoiceNumber: "",
          penultimateInvoiceNumber: ""
        }}
        onSubmit={values => {
          this.requestAddContact(values);
        }}
        validationSchema={this.validationSchema}
        render={({ handleChange, handleBlur, values, errors, touched }) => (
          <Container>
            <Header>
              <Left>
                {back ? (
                  <BackButton
                    title="Fechar"
                    className="mdi mdi-arrow-left"
                    onClick={() => this.props.dispatch(toggleStep(2))}
                  />
                ) : null}
                <Title>Vincular Novo Contrato</Title>
              </Left>
              <CloseIcon
                title="Fechar"
                className="mdi mdi-close"
                onClick={close}
              />
            </Header>
            <Content>
              Para conseguirmos vincular é necessário o código das duas últimas
              notas fiscais:
            </Content>
            <FieldsContainer>
              <Fields>
                <Form>
                  <BootstrapForm.Group controlId="lastInvoiceNumber">
                    <FormikField
                      render={({ field }) => {
                        return (
                          <Field
                            {...field}
                            type="text"
                            label="Última Nota Fiscal"
                            ariaLabel="Última Nota Fiscal"
                            ariaRequired
                            errorCondition={
                              errors.lastInvoiceNumber &&
                              touched.lastInvoiceNumber
                            }
                            errorMessage={errors.lastInvoiceNumber}
                            title="Última Nota Fiscal"
                            onBlur={handleBlur}
                            placeholder="Última Nota Fiscal"
                            value={values.lastInvoiceNumber}
                            onChange={handleChange}
                          />
                        );
                      }}
                      name="lastInvoiceNumber"
                    />
                  </BootstrapForm.Group>
                  <BootstrapForm.Group controlId="penultimateInvoiceNumber">
                    <FormikField
                      render={({ field }) => {
                        return (
                          <Field
                            {...field}
                            type="text"
                            label="Penúltima Nota Fiscal"
                            ariaLabel="Penúltima Nota Fiscal"
                            ariaRequired
                            errorCondition={
                              errors.penultimateInvoiceNumber &&
                              touched.penultimateInvoiceNumber
                            }
                            errorMessage={errors.penultimateInvoiceNumber}
                            title="Penúltima Nota Fiscal"
                            onBlur={handleBlur}
                            placeholder="Penúltima Nota Fiscal"
                            value={values.penultimateInvoiceNumber}
                            onChange={handleChange}
                          />
                        );
                      }}
                      name="penultimateInvoiceNumber"
                    />
                  </BootstrapForm.Group>
                  <WithoutInvoicesContainer>
                    <WithoutInvoices
                      onClick={() => this.props.dispatch(toggleStep(6))}
                    >
                      Não possuo as Notas Fiscais
                    </WithoutInvoices>
                  </WithoutInvoicesContainer>
                  <ButtonContainer>
                    <StyledButton
                      type="submit"
                      className="mt-4"
                      icon="account-plus"
                      text="Confirmar"
                      loading={this.state.loading}
                      color="#F0B01B"
                    />
                  </ButtonContainer>
                </Form>
              </Fields>
            </FieldsContainer>
          </Container>
        )}
      />
    );
  }
}

const mapStateToProps = state => ({
  userId: state.multiplosReducer.userId,
  customerCode: state.multiplosReducer.user,
  document: state.multiplosReducer.document,
  contactId: state.multiplosReducer.contactId,
  contact: state.multiplosReducer.contact
});

export default connect(mapStateToProps)(Invoices);
